import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import { WebSocketProvider } from "./hooks/useWebSocket";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Operation from "./pages/Operation";
import Research from "./pages/Research";
import Management from "./pages/Management";


function LegacyRedirect({ to, sub }: { to: string; sub?: string }) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  if (sub) query.set("sub", sub);
  return <Navigate replace to={`${to}${query.size ? `?${query}` : ""}${location.hash}`} />;
}

function AuthenticatedApp() {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">시스템 상태 확인 중...</div>;
  }

  if (!authenticated) {
    return <Login />;
  }

  return (
    <WebSocketProvider>
      <Layout>
        <Routes>
          {/* 4 Core Executive Routes */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/operation" element={<Operation />} />
          <Route path="/operation/:tab" element={<Operation />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/:tab" element={<Research />} />
          <Route path="/research/advisory/:reportId" element={<Research />} />
          <Route path="/management" element={<Management />} />
          <Route path="/management/:tab" element={<Management />} />
          <Route path="/management/data/:kind" element={<Management />} />

          {/* Legacy redirects preserve query parameters and hash */}
          <Route path="/positions" element={<LegacyRedirect to="/operation/positions" />} />
          <Route path="/trades" element={<LegacyRedirect to="/operation/trades" />} />
          <Route path="/invest" element={<LegacyRedirect to="/operation/invest" />} />
          <Route path="/control" element={<LegacyRedirect to="/management/control" />} />
          <Route path="/alerts" element={<LegacyRedirect to="/management/alerts" />} />
          <Route path="/logs" element={<LegacyRedirect to="/management/logs" />} />
          <Route path="/risk" element={<LegacyRedirect to="/management/risk" />} />
          <Route path="/news" element={<LegacyRedirect to="/management/data" sub="news" />} />
          <Route path="/calendar" element={<LegacyRedirect to="/management/data" sub="calendar" />} />
          <Route path="/saveticker" element={<LegacyRedirect to="/management/data" sub="saveticker" />} />
          <Route path="/llm-intel" element={<LegacyRedirect to="/management/data" sub="llm-intel" />} />
          <Route path="/models" element={<LegacyRedirect to="/management/data" sub="models" />} />
          <Route path="/export" element={<LegacyRedirect to="/management/data" sub="export" />} />

          {/* Catch-all */}
          <Route path="*" element={<div className="card"><h2>페이지를 찾을 수 없습니다</h2><a href="/">홈으로 이동</a></div>} />
        </Routes>
      </Layout>
    </WebSocketProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AuthenticatedApp />
    </AuthProvider>
  );
}
